import { paidList } from "@/mocks/chiagua";

export default function PaidUnlock() {
  return (
    <section id="unlock" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">Exclusive Unlock</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">独家解锁 · 付费内容精选</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            深挖脉络、还原现场，一次读懂复杂瓜点的来龙去脉。解锁后永久可看，会员更能免单畅读。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {paidList.map((p) => (
            <article
              key={p.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  title={p.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {p.cat}
                </span>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-sm font-bold text-foreground-950">
                  <i className="ri-price-tag-3-line"></i> ¥{p.price}
                </div>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2">
                  完整时间线、多方信源交叉核实、幕后资源脉络，一篇讲清这个瓜的前因后果。
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i> {p.readers} 人已解锁
                  </span>
                  <a
                    href="#join"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-lock-unlock-line"></i> 立即解锁
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}